import { baseURL } from '../common'
import { GridExportClient } from './__generated__/GridExport'
import { HttpClient } from './__generated__/http-client'
import { PolygonExportClient } from './__generated__/PolygonExport'
import { PolygonImportClient } from './__generated__/PolygonImport'

const Clients = {
  GridExportClient,
  PolygonExportClient,
  PolygonImportClient,
} as const

const httpClient = new HttpClient({ baseUrl: baseURL })

export function getClient(client: 'GridExportClient'): InstanceType<typeof GridExportClient>
export function getClient(client: 'PolygonImportClient'): InstanceType<typeof PolygonImportClient>
export function getClient(client: 'PolygonExportClient'): InstanceType<typeof PolygonExportClient>
export function getClient(client: keyof typeof Clients) {
  return new Clients[client](httpClient)
}
